import { withCompInfo } from '@wix/editor-elements-integrations'
import {
	getFillLayersColorsVars,
	getFillLayersMediaVars,
	getBackgroundMediaFillLayerCSSVars,
} from '../../core/mappers/FillLayers/FillLayers.utils'
import { getShapeDividersResponsiveCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'

export const css = withCompInfo<any, any>()(
	[
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		'experiments',
		'viewMode',
		'compDesign',
	],
	({
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		experiments,
		viewMode,
		compDesign,
	}) => {
		if (!compDesign) {
			return {}
		}
		const backgroundMediaVars = getBackgroundMediaFillLayerCSSVars({ animations, experiments, viewMode })
		return {
			...(backgroundMediaVars && backgroundMediaVars),
		}
	}
)

export const designCss = withCompInfo<any, any>()(
	[
		'compId',
		'compDesign',
		'siteColors',
		// @ts-ignore - Remove once isDefaultVariant is added to the compInfo
		'isDefaultVariant',
		'compProps',
		'experiments',
		'isMobileView',
		'viewMode',
		'hasResponsiveLayout',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],

	({
		compId,
		compDesign,
		siteColors,
		// @ts-ignore - Remove once isDefaultVariant is added to the compInfo
		isDefaultVariant,
		compProps,
		experiments,
		isMobileView,
		viewMode,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = compDesign?.background

		const mediaFillLayersVars =
			isDefaultVariant && backgroundMedia
				? getFillLayersMediaVars({
						animations,
						backgroundMedia,
						compDesign,
						compProps,
						compId,
						experiments,
						isMobileView,
						isNonAdaptiveMobile,
						viewMode,
				  })
				: {}

		const colorLayers = backgroundMedia
			? getFillLayersColorsVars({
					siteColors,
					backgroundMedia,
			  })
			: {}

		const shapeDividersCSSVars = getShapeDividersResponsiveCSSVars({
			compId,
			compDesign,
			colorsMap: siteColors,
		})

		return {
			...mediaFillLayersVars,
			...colorLayers,
			...shapeDividersCSSVars,
		}
	}
)
